import { render } from "./DialogPromo.vue?vue&type=template&id=d13205da"
import script from "./DialogPromo.vue?vue&type=script&lang=js"
export * from "./DialogPromo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__